import {BlockType, Blocks} from '../blocks/Blocks'
import {
	Contentside,
	ContentsideContent,
	ContentsideFixed,
	ContentsideSidebar
} from '../layout/Contentside'
import {Hero, HeroSide, HeroType} from '../layout/Hero'
import {PersonBlockCollaborator, PersonBlockItem} from '../blocks/PersonBlock'
import {SidebarBlockType, SidebarBlocks} from '../sidebar/SidebarBlocks'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import PublishedOn from '../layout/PublishedOn'
import React from 'react'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('newsdetail')

export type NewsDetailType = {
	hero: HeroType
	collaborator?: PersonBlockCollaborator
	contentblocks?: Array<BlockType>
	sidebarblocks?: Array<SidebarBlockType>
	blocks?: Array<BlockType>
}

export const NewsDetail: React.FC<PageData & NewsDetailType> = wrap(Layout)(
	({...props}) => {
		const {
			parents,
			title,
			hero,
			collaborator,
			contentblocks,
			sidebarblocks,
			blocks
		} = props
		const hasContentside =
			(hero && !hero?.image) ||
			(contentblocks && contentblocks.length > 0) ||
			(sidebarblocks && sidebarblocks.length > 0)
		const date = Date.parse(props.date) ? new Date(props.date) : undefined

		return (
			<div className={styles()}>
				{hero?.image && (
					<Hero {...hero} title={(hero && hero.title) || title} />
				)}
				<Breadcrumbs parents={parents} title={title} />
				<PublishedOn date={date} />
				{(hasContentside || collaborator) && (
					<Contentside>
						<ContentsideContent>
							{(!hero || !hero?.image) && (
								<HeroSide {...hero} title={hero?.title || title} />
							)}
							<Blocks blocks={contentblocks} />
						</ContentsideContent>
						<ContentsideSidebar>
							{collaborator && (
								<ContentsideFixed className={styles('newsdetail-collaborator')}>
									<PersonBlockItem
										{...collaborator}
										collaborator={collaborator}
									/>
								</ContentsideFixed>
							)}
							<SidebarBlocks blocks={sidebarblocks} />
						</ContentsideSidebar>
					</Contentside>
				)}
				<Blocks blocks={blocks} container={true} />
			</div>
		)
	}
)
